module.exports = __webpack_public_path__ + "img/mail-app.675e88dd.jpg";